const criaDialog = (mensagem,titulo) => {
  const alerta = document.createElement('dialog');
  alerta.className = "bg-superficie elev5 alerta-dialog";

  alerta.innerHTML += `
      <div class="dialog-container">
        <div class="dialog-header">
          <img src="/images/carol-perfil.png" />
        </div>

        <div class="dialog-main">
          <h5>${titulo}</h5>
          <span class'pequeno'>${mensagem}</span>
        </div>

        <div class"dialog-footer">
          <button class="btn-txt btn-fecha-dialog">
            Ok
          </button>
        </div>
      </div>
    `;
  
  return alerta;
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const abreAlertaDialog = (mensagem, titulo) => {  
  if(!titulo){
    titulo = 'Meu Correios Informa';
  }
  const alerta = criaDialog(mensagem, titulo);
  document.body.appendChild(alerta);
  
  const botaoFechar = alerta.querySelector('.btn-fecha-dialog');
  alerta.showModal();
  botaoFechar.addEventListener('click', function () {
    alerta.close();
    sleep(1000).then(() => {alerta.remove();});
  });
}

